import React, { useEffect } from "react";
import OwlCarousel from "react-owl-carousel";
import "owl.carousel/dist/assets/owl.carousel.css";
import "owl.carousel/dist/assets/owl.theme.default.css";
import { Link } from 'react-router-dom';
import { BlocksRenderer } from "@strapi/blocks-react-renderer";
import Button from "./Button";

const NewsSlider = ({ aktuelles }) => {

    const options = {
        loop: false,
        margin: 30,
        nav: true,
        dots: false,
        autoplay: false,
        autoplayTimeout: 2000,
        // ✅ DISABLE DRAG
        // pullDrag: false,
        // freeDrag: false,
        responsive: {
            0: { items: 1, margin: 20, nav: false, dots: true, mouseDrag: true, touchDrag: true },
            576: { items: 2, margin: 30, nav: false, dots: true, mouseDrag: true, touchDrag: true },
            1200: { items: 3, mouseDrag: false, touchDrag: false }
        }
    };

    useEffect(() => {
        const equalHeight = () => {
            const elements = document.querySelectorAll(
                ".news_slider .slider_slide_item h4"
            );

            let maxHeight = 0;

            elements.forEach((el) => {
                el.style.height = "auto"; // reset
                maxHeight = Math.max(maxHeight, el.offsetHeight);
            });

            elements.forEach((el) => {
                el.style.height = maxHeight + "px";
            });
        };

        // run on load
        setTimeout(equalHeight, 500);

        // run on resize
        window.addEventListener("resize", equalHeight);

        return () => {
            window.removeEventListener("resize", equalHeight);
        };
    }, []);

    const truncateBlocks = (blocks, maxLength = 120) => {
        if (!blocks) return "";

        let text = "";

        for (let block of blocks) {
            if (block.children) {
                for (let child of block.children) {
                    text += child.text;

                    if (text.length >= maxLength) {
                        return text.slice(0, maxLength) + "...";
                    }
                }
            }
        }

        return text;
    };

    return (
        <div className='slider_wrapper news_slider aktuelles_slider'>
            <OwlCarousel className="owl-theme" {...options}>
                {aktuelles?.map((news, index) => (
                    <div key={index} className='slider_slide_item'>
                        <Link to={`/aktuelles/${news?.slug}`}>
                            <figure className='mb-0 position-relative'>
                                {news?.Modul?.length > 0 && news?.Modul[0]?.Bild?.length > 0 && <img src={`https://backend.bgzurlinden.ch${news?.Modul[0]?.Bild[0]?.url}`} className='w-100' alt='#' />}
                                {/* {news?.Modul[0]?.Bild[0]?.url && <img src={`https://backend.bgzurlinden.ch${news?.Modul[0]?.Bild[0]?.url}`} className='w-100' alt='#' />} */}
                                <span className={`post_tag bg-${news?.aktuelles_kategorie?.Farbe?.split(" ")[0]}`}>{news?.aktuelles_kategorie?.Titel}</span>
                            </figure>
                        </Link>
                        <div className='figcaption'>
                            <h4 className="text-black"><Link to={`/aktuelles/${news?.slug}`}>{news?.Bannerbereich[0]?.Titel}</Link></h4>
                            {news?.Bannerbereich[0]?.Beschreibung && (
                                <p>{truncateBlocks(news.Bannerbereich[0]?.Beschreibung, 70)}</p>
                            )}
                            <div className='post-footer'>
                                <Link to={`/aktuelles/${news?.slug}`} className='button round_btn btn-blue-color'>lesen
                                    <span>
                                        <svg width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <path d="M20.7733 15.4513C20.7593 16.0532 20.2599 16.5526 19.6579 16.5667C19.056 16.5807 18.5794 16.1041 18.5934 15.5021L18.9037 2.20548L5.60703 2.51577C5.00507 2.52982 4.52846 2.05321 4.54251 1.45125C4.55657 0.849296 5.05594 0.349907 5.6579 0.33586L20.0445 0.000170705C20.6465 -0.0138708 21.1231 0.462731 21.109 1.06469L20.7733 15.4513Z" fill="inherit" />
                                            <path d="M1.84309 20.7715C1.40751 21.2071 0.717391 21.2232 0.301672 20.8075C-0.114047 20.3918 -0.0979427 19.7017 0.337642 19.2661L19.2663 0.337392C19.7019 -0.0981931 20.3921 -0.114298 20.8078 0.301422C21.2235 0.717141 21.2074 1.40726 20.7718 1.84284L1.84309 20.7715Z" fill="inherit" />
                                        </svg>
                                    </span>
                                </Link>
                                <span className='post_date'>
                                    {new Date(news?.Publikation).toLocaleDateString('de-DE', {
                                        day: '2-digit',
                                        month: '2-digit',
                                        year: 'numeric',
                                    })}
                                </span>
                            </div>
                        </div>
                    </div>
                ))}
            </OwlCarousel>
        </div>
    )
}

export default NewsSlider